/* Tischlein Wunschliste: baut aus dem Warenkorb eine Anfrage und schickt sie über das Kontaktformular an Lisa. */
(function (root) {
  'use strict';

  function clean(value) {
    return (value || '').trim();
  }

  function formatEuro(cents) {
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts[0] + ',' + parts[1] + ' €';
  }

  function formatDate(iso) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    return match ? match[3] + '.' + match[2] + '.' + match[1] : '';
  }

  // Das Anfrage-Objekt ist die Schnittstelle für Stufe 2 (Bestellentwurf in Shopify).
  function buildRequest(cart, fields) {
    var items = cart.items.map(function (item) {
      return {
        variantId: item.variant_id,
        quantity: item.quantity,
        sku: item.sku || '',
        title: item.product_title,
        variant: item.variant_title || '',
        unitPrice: item.final_price,
        lineTotal: item.final_line_price
      };
    });
    return {
      customer: { name: clean(fields.name), email: clean(fields.email), phone: clean(fields.phone) },
      pickupDate: clean(fields.pickupDate),
      returnDate: clean(fields.returnDate),
      occasion: clean(fields.occasion),
      message: clean(fields.message),
      items: items,
      itemCount: items.reduce(function (sum, item) { return sum + item.quantity; }, 0),
      total: items.reduce(function (sum, item) { return sum + item.lineTotal; }, 0)
    };
  }

  function formatFees(fees) {
    if (!fees || !fees.length) return [];
    return ['', 'Mögliche Pauschalen:'].concat(fees.map(function (fee) {
      var betrag = String(fee.betrag || '');
      return '- ' + String(fee.name || '') + (betrag ? ': ' + betrag : '');
    }));
  }

  function formatMail(request, restoreLink, fees) {
    var subject = 'Wunschliste von ' + request.customer.name + ' - ' + request.itemCount + ' Artikel' +
      (request.pickupDate ? ' - Abholung ' + formatDate(request.pickupDate) : '');
    var lines = [
      subject,
      '',
      'Name: ' + request.customer.name,
      'E-Mail: ' + request.customer.email,
      'Telefon: ' + request.customer.phone
    ];
    if (request.pickupDate) lines.push('Abholung: ' + formatDate(request.pickupDate));
    if (request.returnDate) lines.push('Rückgabe: ' + formatDate(request.returnDate));
    if (request.occasion) lines.push('Anlass: ' + request.occasion);
    if (request.message) lines.push('Nachricht: ' + request.message);
    lines.push('', 'ARTIKEL');
    request.items.forEach(function (item) {
      lines.push(
        item.quantity + ' x ' + item.title + (item.variant ? ' - ' + item.variant : '') +
        (item.sku ? ' (SKU ' + item.sku + ')' : '') +
        ' à ' + formatEuro(item.unitPrice) + ' = ' + formatEuro(item.lineTotal)
      );
    });
    lines.push('', 'Gesamt: ' + formatEuro(request.total), '(ohne Pauschalen und Zusatzleistungen)');
    lines = lines.concat(formatFees(fees));
    if (restoreLink) lines.push('', 'Liste im Shop öffnen: ' + restoreLink);
    return lines.join('\n');
  }

  var WHATSAPP_MAX_LINES = 40;

  // Shopify-Warenkorb-Link: stellt genau diese Artikel und Mengen wieder her, ohne zur Kasse zu springen.
  function buildRestoreLink(request, origin) {
    return origin + '/cart/' + request.items.map(function (item) {
      return item.variantId + ':' + item.quantity;
    }).join(',') + '?storefront=true';
  }

  function formatWhatsApp(request, restoreLink, fees) {
    var lines = ['Hallo Lisa, hier ist meine Wunschliste (' + request.itemCount + ' Artikel, Summe der Mietpreise ' + formatEuro(request.total) + ').'];
    if (request.pickupDate) lines.push('Abholung: ' + formatDate(request.pickupDate));
    if (request.returnDate) lines.push('Rückgabe: ' + formatDate(request.returnDate));
    // Sehr lange WhatsApp-Links brechen auf manchen Handys ab, dann reicht der Link zur Liste.
    if (request.items.length <= WHATSAPP_MAX_LINES) {
      lines.push('');
      request.items.forEach(function (item) {
        lines.push(item.quantity + ' x ' + item.title + (item.variant ? ' - ' + item.variant : ''));
      });
    }
    lines = lines.concat(formatFees(fees));
    lines.push('', 'Liste im Shop öffnen: ' + restoreLink);
    return lines.join('\n');
  }

  function buildWhatsAppUrl(number, text) {
    return 'https://wa.me/' + String(number || '').replace(/\D/g, '') + '?text=' + encodeURIComponent(text);
  }

  var api = {
    formatEuro: formatEuro,
    formatDate: formatDate,
    buildRequest: buildRequest,
    formatMail: formatMail,
    buildRestoreLink: buildRestoreLink,
    formatWhatsApp: formatWhatsApp,
    buildWhatsAppUrl: buildWhatsAppUrl
  };

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root) return;
  root.TsdWishlist = api;
  if (root.__tsdWishlistReady) return;
  root.__tsdWishlistReady = true;

  var STORAGE_KEY = 'tsd-wishlist-last-request';
  var shopRoot = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
  var origin = root.location.origin;

  function fetchCart() {
    return fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        if (!cart.items.length) throw new Error('empty cart');
        return cart;
      });
  }

  function readFees() {
    try {
      var el = document.querySelector('[data-tsd-fees]');
      var fees = el ? JSON.parse(el.textContent) : [];
      return Array.isArray(fees) ? fees : [];
    } catch (e) {
      return [];
    }
  }

  function readFields(scope) {
    var fields = {};
    scope.querySelectorAll('[data-tsd-field]').forEach(function (input) {
      fields[input.getAttribute('data-tsd-field')] = input.value;
    });
    return fields;
  }

  function setRestoreLink(scope, url) {
    scope.querySelectorAll('[data-tsd-restore]').forEach(function (box) {
      var link = box.querySelector('[data-tsd-restore-link]');
      if (link) {
        link.href = url;
        link.textContent = url;
      }
      box.hidden = false;
    });
    scope.querySelectorAll('[data-tsd-copy]').forEach(function (button) { button.hidden = false; });
  }

  function updateWhatsApp(dialog) {
    var step = dialog.querySelector('[data-tsd-step="whatsapp"]');
    var link = step.querySelector('[data-tsd-whatsapp]');
    var error = step.querySelector('[data-tsd-error]');
    var seq = dialog.__tsdWaSeq = (dialog.__tsdWaSeq || 0) + 1;
    link.setAttribute('aria-disabled', 'true');
    if (error) error.hidden = true;
    fetchCart()
      .then(function (cart) {
        if (seq !== dialog.__tsdWaSeq) return;
        var request = buildRequest(cart, readFields(step));
        var restore = buildRestoreLink(request, origin);
        link.href = buildWhatsAppUrl(dialog.getAttribute('data-tsd-whatsapp-number'), formatWhatsApp(request, restore, readFees()));
        link.removeAttribute('aria-disabled');
        setRestoreLink(step, restore);
      })
      .catch(function () {
        if (seq !== dialog.__tsdWaSeq) return;
        if (error) error.hidden = false;
      });
  }

  function showStep(dialog, name) {
    dialog.querySelectorAll('[data-tsd-step]').forEach(function (step) {
      step.hidden = step.getAttribute('data-tsd-step') !== name;
    });
    if (name === 'whatsapp') updateWhatsApp(dialog);
  }

  function openDialog(dialog, step) {
    showStep(dialog, step || 'choose');
    if (!dialog.open) dialog.showModal();
  }

  function copyLink(button) {
    var scope = button.closest('[data-tsd-thanks], [data-tsd-step]') || document;
    var link = scope.querySelector('[data-tsd-restore-link]');
    if (!link || !root.navigator.clipboard) return;
    if (!button.dataset.label) button.dataset.label = button.textContent;
    var label = button.dataset.label;
    root.navigator.clipboard.writeText(link.href).then(function () {
      button.textContent = 'Kopiert';
      root.setTimeout(function () { button.textContent = label; }, 2000);
    }).catch(function () {});
  }

  // Delegiert am document, weil Horizon den Warenkorb-Bereich austauscht (Template-Klon, Morph).
  document.addEventListener('click', function (event) {
    if (event.target.matches && event.target.matches('dialog[data-tsd-dialog]')) {
      var box = event.target.getBoundingClientRect();
      var outside = event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
      if (outside && !(event.clientX === 0 && event.clientY === 0)) event.target.close();
      return;
    }
    var target = event.target.closest && event.target.closest(
      '[data-tsd-open], [data-tsd-step-target], [data-tsd-close], [data-tsd-whatsapp], [data-tsd-copy], [data-tsd-print], [data-tsd-new-list]'
    );
    if (!target) return;
    var wishlist = target.closest('.tsd-wishlist');
    var dialog = wishlist && wishlist.querySelector('[data-tsd-dialog]');

    if (target.hasAttribute('data-tsd-open')) {
      if (dialog) openDialog(dialog);
    } else if (target.hasAttribute('data-tsd-step-target')) {
      if (dialog) showStep(dialog, target.getAttribute('data-tsd-step-target'));
    } else if (target.hasAttribute('data-tsd-close')) {
      if (dialog) dialog.close();
    } else if (target.hasAttribute('data-tsd-whatsapp')) {
      if (target.getAttribute('aria-disabled') === 'true') event.preventDefault();
    } else if (target.hasAttribute('data-tsd-copy')) {
      copyLink(target);
    } else if (target.hasAttribute('data-tsd-print')) {
      root.print();
    } else if (target.hasAttribute('data-tsd-new-list')) {
      if (!root.confirm('Möchtest Du Deine Wunschliste wirklich leeren?')) return;
      fetch(shopRoot + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .catch(function () {})
        .then(function () { root.location.href = shopRoot + 'cart'; });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || event.isComposing) return;
    if (!event.target.matches || !event.target.matches('input')) return;
    var step = event.target.closest && event.target.closest('[data-tsd-step="whatsapp"]');
    if (!step) return;
    event.preventDefault();
    updateWhatsApp(step.closest('[data-tsd-dialog]'));
  });

  document.addEventListener('change', function (event) {
    var step = event.target.closest && event.target.closest('[data-tsd-step="whatsapp"]');
    if (!step) return;
    updateWhatsApp(step.closest('[data-tsd-dialog]'));
  });

  // Ein Listener am document (Capture), weil Horizon den Warenkorb-Bereich austauscht (Template-Klon, Morph)
  // und Shopifys hCaptcha einen eigenen submit-Listener am Formular hat. Erster Durchlauf: wir halten das
  // Absenden an, holen den Warenkorb und füllen die Nachricht. Zweiter Durchlauf (tsdReady): wir lassen
  // hCaptcha und Shopify das fertige Formular normal absenden.
  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[data-tsd-wishlist-form]');
    if (!form) return;
    if (form.dataset.tsdReady === '1') {
      delete form.dataset.tsdReady;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    var emailStep = form.querySelector('[data-tsd-step="email"]') || form;
    if (emailStep.hidden) return;
    if (!form.reportValidity()) return;
    var error = emailStep.querySelector('[data-tsd-error]');
    var button = event.submitter || emailStep.querySelector('[type="submit"]');
    if (error) error.hidden = true;
    if (button) button.disabled = true;
    fetchCart()
      .then(function (cart) {
        var request = buildRequest(cart, readFields(emailStep));
        form.querySelector('[name="contact[body]"]').value = formatMail(request, buildRestoreLink(request, origin), readFees());
        try { root.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(request)); } catch (e) {}
        form.dataset.tsdReady = '1';
        // Button wieder aktivieren, sonst fehlt er im Formular-Absenden (disabled-Submitter wird abgelehnt).
        if (button) button.disabled = false;
        var dlg = form.querySelector('[data-tsd-dialog]');
        if (dlg && dlg.open) dlg.close();
        if (form.requestSubmit) form.requestSubmit(button || undefined);
        else HTMLFormElement.prototype.submit.call(form);
      })
      .catch(function () {
        delete form.dataset.tsdReady;
        if (button) button.disabled = false;
        if (error) error.hidden = false;
      });
  }, true);

  // Danke-Ansicht: Liste bleibt stehen, wir zeigen den Link dazu.
  function initThanks(box) {
    try {
      var request = JSON.parse(root.sessionStorage.getItem(STORAGE_KEY));
      if (request) {
        var restore = buildRestoreLink(request, origin);
        var list = box.querySelector('[data-tsd-thanks-list]');
        if (list) list.textContent = formatMail(request, restore);
        setRestoreLink(box, restore);
      }
    } catch (e) {}
    try { root.history.replaceState(null, '', root.location.pathname); } catch (e) {}
  }

  document.querySelectorAll('[data-tsd-thanks]').forEach(initThanks);
  document.querySelectorAll('[data-tsd-dialog][data-tsd-open-on-load]').forEach(function (dialog) {
    openDialog(dialog, dialog.getAttribute('data-tsd-open-on-load'));
  });
})(typeof window !== 'undefined' ? window : null);
